<script>
import appConfig from "@/app.config";
import axios from "axios";
import { FormWizard, TabContent } from 'vue-form-wizard';
import { WebCam } from 'vue-web-cam';

export default {
  page: {
    title: "Register",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
    components: { FormWizard, TabContent,'vue-web-cam':WebCam },
  data() {
    return {
      error: "",
      loader: false,
      phone: localStorage.getItem("phone"),
      currentdate:new Date().toLocaleDateString('fr-CA'),
      firstname: "",
      lastname: "",
      nin: "",
      dob: "",
      gender:"",
      village_id: "",
      districts: [], district: "",
      parishes: [], parish: "",
      constituencies: [],  constituency: "",
      subcounties: [], subcounty: "",
      villages: [], village: "",
      photo: "",
      email: "",
      memberphoto: null, selectdev:true,
      memberData: JSON.parse(localStorage.getItem("member")),
    };
  },
  mounted() {
    this.getDistricts();
  },
  methods: {
    async getDistricts() {
      axios.get("/get_districts").then((response) => {
        this.districts = response.data.data;
      });
    },
    async FilterConstituencies() {
      if (this.district) {
        axios.get("/get_constitiuencies/" + this.district).then((response) => {
          this.constituencies = response.data.data;
        });
      } else {
        this.constituencies = [];
      }
    },
    async FilterSubcounties() {
      if (this.constituency) {
        axios.get("/get_subcounties/" + this.constituency).then((response) => {
          this.subcounties = response.data.data;
        });
      } else {
        this.subcounties = [];
      }
    },
    async FilterParishes() {
      if (this.subcounty) {
        axios.get("/get_parishes/" + this.subcounty).then((response) => {
          this.parishes = response.data.data;
        });
      } else {
        this.parishes = [];
      }
    },
    async FilterVillages() {
      if (this.parish) {
        axios.get("/get_villages/" + this.parish).then((response) => {
          this.villages = response.data.data;
        });
      } else {
        this.villages = [];
      }
    },

    async take_photo () {  
      const image = await this.$refs.webcam.capture(); 
      this.photo = image;
      const binaryData = this.convertBase64ToBinary(image);
      this.saveBinary(binaryData);
    },

    convertBase64ToBinary(base64String) {
      const byteString = atob(base64String.split(',')[1]);
      const byteNumbers = new Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        byteNumbers[i] = byteString.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      return byteArray;
    },

    saveBinary(binaryData) {
      const blob = new Blob([binaryData], { type: 'image/jpeg' });
      this.memberphoto= blob;
    },

    getLastTwoDigitsOfYear(date) {
      if (!date) return '';
      const parsedDate = new Date(date);
      if (isNaN(parsedDate.getTime())) return '';
      return parsedDate.getFullYear().toString().slice(-2);
    },

    validateBioData() {
      let valid = true;

      if (!this.phone || this.phone.length !== 9) {
        alert('Please enter a valid 9-digit phone number');
        valid = false;
      }
      if (!this.firstname.trim()) {
        alert('Please enter your first name');
        valid = false;
      }
      if (!this.lastname.trim()) {
        alert('Please enter your last name');
        valid = false;
      }

      if (!this.nin.trim()) {
        alert('Please enter your NIN');
        valid = false;
      } else {
        const year = this.getLastTwoDigitsOfYear(this.dob);
        if (!year) {
        alert('Invalid date of birth');
        valid = false;
        } else {
          const pattern = new RegExp(`^(CM|CF)${year.padStart(2, '0')}[A-Z0-9]{10}$`);
          if (!pattern.test(this.nin)) {
            alert('NIN must start with CM or CF, followed by the last two digits of your birth year, and 10 alphanumeric characters');
            valid = false;
          }
        }
      }
      return valid;
    },
    
    validateAddressData() {
      let valid = true;

      if (!this.village) {
        alert('Please enter a Village');
        valid = false;
      }else{
        this.inserBioData();
        valid = true;
      }
      return valid;
    },

    beforeChange(prevIndex, nextIndex) {
      if (prevIndex === 0 && nextIndex > 0) {
        if (!this.validateBioData()) {
          return false; // Prevent tab change
        }
      }
      if (prevIndex === 1 && nextIndex > 1) {
        if (!this.validateAddressData()) {
          return false; // Prevent tab change
        }
      }
      return true; // Allow tab change
    },

    inserBioData() {
      this.loader = true;
      let formData = new FormData();
      formData.append("phone", "+256"+this.phone);
      formData.append("first_name", this.firstname);
      formData.append("last_name", this.lastname);
      formData.append("NIN", this.nin);
      formData.append("DOB", this.dob);
      formData.append("sex", this.gender);
      formData.append("village_id", this.village);
      let url = "/register_member";
      axios.post(url, formData).then((response) => {
        if (response.data.error == false) {
          this.error = "";
          this.loader = false;
          localStorage.setItem("member", JSON.stringify(response.data.data));
        } else {
          this.error = response.data.msg;
          this.loader = false;
        }
      }).catch((error) => {
        this.error = error.response ? error.response.data.msg : "An error occurred";
        this.loader = false;
      });
    },

    onComplete() {

      if (this.memberphoto) {
        this.member_id = this.memberData.id;
        let formData = new FormData();
        formData.append("image", this.memberphoto);
        formData.append("email", this.email);
        let url = "/update_profile/"+this.member_id;
        axios.post(url, formData).then((response) => {
          if (response.status == 200) {
            this.error = "";
            this.loader = false;
            localStorage.setItem("member", JSON.stringify(response.data.data));
            this.$swal({ title:'Success', text:response.data.message, icon:'success'});
            this.$router.push({ name: "home" });
          } else {
            this.error = response.data.msg;
            this.loader = false;
          }
        }).catch((error) => {
          this.error = error.response ? error.response.data.msg : "An error occurred";
          this.loader = false;
        });
      } else {
        alert("Please take a photo before submitting.");
      }
    },

  },
};
</script>

<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row g-0">
        <div class="col-xl-8 mx-auto">
          <div class="auth-full-page-content p-md-5 p-4">
            <div class="w-100">
              <div class="d-flex flex-column h-100">
                <div class="my-auto">
                  <div class="d-flex flex-row">
                    <span class="mt-3"
                      ><br /><img height="60px" src="@/assets/images/logo.jpeg"
                    /></span>
                    <span class="mt-5 ms-3"
                      ><h5 class="text-primary">You`re Welcome !</h5>
                      <p class="text-muted">
                        Please fill the information below to continue
                      </p></span
                    >
                  </div>
                  <div
                    v-if="error"
                    class="bg-danger text-white p-2 mt-3"
                    style="font-size:12px"
                  >
                    {{ error }}
                  </div>
                  <div class="mt-2">
                    <form-wizard
                      :start-index="0" :show-progress="true" :show-step-indicator="true" :use-local-storage="false" :locale="'en'"                       
                      :progress-bar-color="'#01A4EFFF'" @on-complete="onComplete()" shape="pill" back-button-text="Previous" next-button-text="Next" finish-button-text="Submit" color="#01A4EFFF">
                    <tab-content title="Bio Data" icon="mdi mdi-account" :before-change="validateBioData">
                    <div class="row"> 
                    <div class="col-md-4 mb-1">
                      <label>Phonenumber</label> <small class="text-danger">*</small>
                      <b-input-group prepend="+256"><input v-model="phone" required placeholder="Enter Phone Number" v-mask="'#########'" type="text" class="form-control"/></b-input-group>
                    </div>
                    <b-form-group class="col-md-4 mb-1" label="First Name">
                      <b-form-input v-model="firstname" type="text" placeholder="Enter First name"></b-form-input>
                    </b-form-group>
                    <b-form-group class="col-md-4 mb-1" label="Last Name">
                      <b-form-input v-model="lastname" type="text" placeholder="Enter Last name"></b-form-input>
                    </b-form-group>
                    <div class="col-md-4 mb-1">
                      <label>Gender</label>
                      <select class="form-control" v-model="gender"><option>Female</option><option>Male</option></select>
                    </div>
                    <b-form-group class="col-md-4 mb-1" label="Date of Birth">
                      <b-form-input v-model="dob" type="date" :max="currentdate" placeholder="Enter Date of Birth"></b-form-input>
                    </b-form-group>
                    <b-form-group class="col-md-4 mb-1" label="NIN">
                      <b-form-input v-model="nin" type="text" placeholder="Enter NIN"></b-form-input>
                    </b-form-group>

                  </div>
                </tab-content>

                <tab-content title="Address Details" icon="fas fa-map-marker-alt" :before-change="validateAddressData">
                    <div class="row">
                    <b-form-group class="col-md-4 mb-1" label="District" >
                      <v-select :options="districts" @input="FilterConstituencies" placeholder="Enter District" v-model="district" label="name" :reduce="district => district.id"></v-select>
                    </b-form-group>

                    <b-form-group v-if="constituencies.length>0" class="col-md-4 mb-1" label="Constituency">
                      <v-select :options="constituencies"  @input="FilterSubcounties"  placeholder="Enter Constituency" v-model="constituency" label="name" :reduce="constituency => constituency.id"></v-select>
                    </b-form-group>

                    <b-form-group v-if="subcounties.length>0" class="col-md-4 mb-1" label="Subcounty">
                      <v-select :options="subcounties"  @input="FilterParishes"  placeholder="Enter Subcounty" v-model="subcounty" label="name" :reduce="subcounty => subcounty.id"></v-select>
                    </b-form-group>

                    <b-form-group v-if="parishes.length>0" class="col-md-4 mb-1" label="Parish">
                      <v-select :options="parishes"  @input="FilterVillages"  placeholder="Enter Parish" v-model="parish" label="name" :reduce="parish => parish.id"></v-select>
                    </b-form-group>

                    <b-form-group v-if="villages.length>0" class="col-md-4 mb-1" label="Village">
                      <v-select :options="villages" placeholder="Enter Village" v-model="village" label="name" :reduce="village => village.id"></v-select>
                    </b-form-group>
                  </div>
                </tab-content>
                <tab-content title="Other Information" icon="mdi mdi-clipboard-text">
                  <div class="row">
                      <div class="col-6">
                        <vue-web-cam height="100"  ref='webcam' :autoplay="true" :selectFirstDevice='selectdev'/>
                        <center><b-button type="button" class="btn btn-sm btn-success" @click="take_photo"><i class="mdi mdi-camera"></i> Take Photo</b-button></center>
                      </div>
  
                      <div class="col-6">
                        <img :src="photo" style="height:100px;border-radius: 5px" />
                      </div>
                    </div>
                    <b-form-group class="col-12 mb-1" label="Email">
                      <b-form-input v-model="email" type="email" placeholder="Enter Email"></b-form-input>
                    </b-form-group>
                    
                    
                </tab-content>
              </form-wizard>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>